import PortalDynamicsService from "./bases/PortalDynamicsService";

class TenantsDynamicsService extends PortalDynamicsService{
    async ObterTenant(tenantId){
        return await this.get(`Tenant/${tenantId}`)
    }
}

export default new TenantsDynamicsService();
